export class TransactionState {
}



// WEBPACK FOOTER //
// webpack://OktaAuth/lib/tx/TransactionState.ts